import { Outlet, useNavigate } from 'react-router-dom';
import styles from '../css/AuthLayout.module.css';

const AuthLayout = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.authLayout}>
      <button className={styles.backButton} onClick={() => navigate(-1)} aria-label="Назад">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <Outlet />
    </div>
  );
};

export default AuthLayout;
